import { memo, useEffect } from 'react';

import { VerticalTimeline } from 'PDF/components/Timeline/VerticalTimeline';
import { PDF_SECTIONS } from 'PDF/constants/sections';
import { getStages, prepareSectionId } from 'PDF/helpers/pdfMapping';
import { useGenerateImageFromElement } from 'PDF/hooks/useGenerateImageFromElement';
import { getAboutCompanyProps } from 'PDF/pages/AboutTheCompany/mapping';
import { IPdfPageProps } from 'PDF/types/pdf';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanChapters, getBusinessPlanType } from 'store/useBusinessToolStore/selectors';

import { useExamplePreview } from 'hooks/useExamplePreview';

export const AboutTheCompany = memo(({ saveSectionProps, sectionPicture }: IPdfPageProps) => {
  const businessPlanChapters = useBusinessToolStore(getBusinessPlanChapters);
  const businessPlanType = useBusinessToolStore(getBusinessPlanType);
  const { isExamplePage } = useExamplePreview();

  const {
    magazineItems,
    generalInfoTableData,
    missionAndVisionTableData,
    goalsAndObjectivesTableData,
    swotTableData,
    historicalEventsTimelineData,
  } = getAboutCompanyProps(businessPlanChapters, businessPlanType, isExamplePage);
  const stages = getStages(businessPlanChapters);

  const [portal, imageSrc] = useGenerateImageFromElement(
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <VerticalTimeline data={historicalEventsTimelineData} />
    </div>,
  );

  useEffect(() => {
    if (imageSrc && sectionPicture) {
      saveSectionProps(prepareSectionId(businessPlanType, PDF_SECTIONS.ABOUT_COMPANY), {
        magazineItems,
        generalInfoTableData,
        missionAndVisionTableData,
        goalsAndObjectivesTableData,
        swotTableData,
        historicalEventsTimelineImageSrc: imageSrc,
        historicalEventsTimelineData,
        stages,
      });
    }
  }, [imageSrc, sectionPicture]);

  return <>{portal}</>;
});
